import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

const Appointment = () => {
  return (
    <>
      <Header />
      <main className="rbt-main-wrapper">
        <div className="rbt-putchase-guide-area rbt-section-gap" style={{ padding: 0 }}>
          <div className="container-fluid" style={{ padding: 0 }}>
            <div className="rbt-article-content-wrapper" style={{ padding: 0 }}>
              <iframe
                src="https://capitalcustomclothiers.setmore.com/"
                title="Book an Appointment - Capital Custom Clothiers"
                style={{
                  width: '100%',
                  height: '90vh',
                  border: 'none',
                }}
                allowFullScreen
              ></iframe>
            </div>
          </div>
        </div>

        <Footer />
      </main>

      {/* <!-- End Page Wrapper Area --> */}
      <div className="rbt-progress-parent">
        <svg className="rbt-back-circle svg-inner" width="100%" height="100%" viewBox="-1 -1 102 102">
          <path d="M50,1 a49,49 0 0,1 0,98 a49,49 0 0,1 0,-98" />
        </svg>
      </div>
    </>
  );
};

export default Appointment;
